import {InputmaskRule} from '../rules';

const datePreset = new InputmaskRule('Неправильный формат даты')
    .completed()
    .final()

export {datePreset}
